import { createContext, useContext } from 'react';
import {
  LINK_PREMIUM_BOTH,
  LINK_PREMIUM_FIVE_TOURNAMENTS,
  LINK_PREMIUM_MONTHLY,
  LINK_PREMIUM_ONE_TOURNAMENT,
  LINK_PREMIUM_SUMMER,
  LINK_PREMIUM_TEN_TOURNAMENTS,
  LINK_PREMIUM_YEARLY,
  PRICE_PREMIUM_FIVE_TOURNAMENTS,
  PRICE_PREMIUM_MONTHLY,
  PRICE_PREMIUM_ONE_TOURNAMENT,
  PRICE_PREMIUM_SUMMER,
  PRICE_PREMIUM_TEN_TOURNAMENTS,
  PRICE_PREMIUM_YEARLY,
} from '@features/chessrussian/customizations/constants';

export type PremiumLinksCtxType = {
  // Monthly
  monthlyLink: string;
  monthlyPrice: string;
  monthlyOldPrice?: string;

  // Yearly
  yearlyLink: string;
  yearlyPrice: string;
  yearlyOldPrice?: string;

  // Summer
  summerLink: string;
  summerPrice: string;

  // One tournament
  oneTournamentLink: string;
  oneTournamentPrice: string;
  oneTournamentOldPrice?: string;

  // Five tournaments
  fiveTournamentsLink: string;
  fiveTournamentsPrice: string;
  fiveTournamentsOldPrice?: string;

  // Ten tournaments
  tenTournamentsLink: string;
  tenTournamentsPrice: string;
  tenTournamentsOldPrice?: string;

  // Both
  bothLink: string;

  //
  isLoading: boolean;
};

export const PremiumLinksCtx = createContext<PremiumLinksCtxType>({
  monthlyLink: LINK_PREMIUM_MONTHLY,
  monthlyPrice: PRICE_PREMIUM_MONTHLY,
  summerLink: LINK_PREMIUM_SUMMER,
  summerPrice: PRICE_PREMIUM_SUMMER,
  yearlyLink: LINK_PREMIUM_YEARLY,
  yearlyPrice: PRICE_PREMIUM_YEARLY,
  bothLink: LINK_PREMIUM_BOTH,
  oneTournamentLink: LINK_PREMIUM_ONE_TOURNAMENT,
  oneTournamentPrice: PRICE_PREMIUM_ONE_TOURNAMENT,
  fiveTournamentsLink: LINK_PREMIUM_FIVE_TOURNAMENTS,
  fiveTournamentsPrice: PRICE_PREMIUM_FIVE_TOURNAMENTS,
  tenTournamentsLink: LINK_PREMIUM_TEN_TOURNAMENTS,
  tenTournamentsPrice: PRICE_PREMIUM_TEN_TOURNAMENTS,
  isLoading: false,
});

export function usePremiumLinksCtx() {
  return useContext(PremiumLinksCtx);
}
